import { combineReducers } from "redux";
import { foundReducer, FoundState } from "found";

import { annotationDialogReducer, IAnnotationDialogState } from "./annotation-dialog.reducer";
import { authReducer, IAuthState } from "./auth.reducer";
import { webExtensionReducer, IWebExtensionState } from "./chrome-extension.reducer";
import { chromeFeedReducer, IChromeFeedState } from "./chrome-feed.reducer";
import { confettiReducer, IConfettiState } from "./confetti.reducer";
import { dayViewReducer, IDayViewState } from "./day-view.reducer";
import { featureGridReducer } from "./feature-grid.reducer";
import { IFeatureGridReduxState } from "@clockwise/web-commons/src/util/feature-grid.util";
// import { PostMessageManager } from "@util/post-message.util";
import { navTabsReducer, INavTabsState } from "./nav-tabs.reducer";
import { errorReducer, IErrorState } from "./error.reducer";
import { feedSchedulerReducer, IFeedSchedulerState } from "./feed-scheduler.reducer";
import { onboardingReducer, IOnboardingState } from "./onboarding.reducer";
import { reschedulerReducer, IReschedulerState } from "./rescheduler.reducer";
import { settingsReducer, ISettingsState } from "./settings.reducer";
import { snackBarReducer, ISnackBarState } from "./snack-bar.reducer";
import { sudoReducer, ISudoState } from "./sudo.reducer";
import { teamHealthReducer, ITeamHealthState } from "./team-health.reducer";
import { weekViewReducer, IWeekViewState } from "./week-view.reducer";
import { paymentsReducer, IPaymentsState } from "./payments.reducer";
import {
  initialSharedState,
  ISharedState,
  sharedReducerFactory,
} from "@clockwise/web-commons/src/state";
import { networkFailureScale } from "@clockwise/web-commons/src/util/local-storage";

export interface IReduxState {
  annotationDialog: IAnnotationDialogState;
  auth: IAuthState;
  confetti: IConfettiState;
  webExtension: IWebExtensionState;
  chromeFeed: IChromeFeedState;
  dayView: IDayViewState;
  featureGrid: IFeatureGridReduxState;
  feedScheduler: IFeedSchedulerState;
  onboarding: IOnboardingState;
  error: IErrorState;
  found: FoundState;
  navTabs: INavTabsState;
  rescheduler: IReschedulerState;
  settings: ISettingsState;
  snackBar: ISnackBarState;
  teamHealth: ITeamHealthState;
  sudo: ISudoState;
  weekView: IWeekViewState;
  payments: IPaymentsState;
  shared: ISharedState;
}

// combine all reducers here
export const rootReducer = combineReducers<IReduxState>({
  annotationDialog: annotationDialogReducer,
  auth: authReducer as any,
  confetti: confettiReducer,
  webExtension: webExtensionReducer as any,
  chromeFeed: chromeFeedReducer,
  dayView: dayViewReducer as any,
  error: errorReducer,
  featureGrid: featureGridReducer,
  feedScheduler: feedSchedulerReducer as any,
  found: foundReducer,
  onboarding: onboardingReducer,
  navTabs: navTabsReducer,
  rescheduler: reschedulerReducer,
  settings: settingsReducer,
  snackBar: snackBarReducer,
  sudo: sudoReducer,
  teamHealth: teamHealthReducer,
  weekView: weekViewReducer,
  payments: paymentsReducer,
  // TODO: synced state
  // shared between chrome-extension and webapp
  shared: sharedReducerFactory(
    {
      ...initialSharedState,
      networkFailureScale: networkFailureScale.get(),
    },
    undefined, // PostMessageManager.sendSyncedAction,
    undefined, // (initialState, otherInitialState) => ({
    //   ...initialState,
    //   ...otherInitialState,
    // }),
    (prevState, newState) => {
      if (prevState.networkFailureScale !== newState.networkFailureScale) {
        networkFailureScale.set(newState.networkFailureScale);
      }
    },
  ),
});
